'use client';

import { LOCALES, LOCALE_LABELS, LOCALE_SHORT_LABELS, type Locale } from './locale.js';
import { useLocale } from './context.js';

/**
 * Language toggle for the app header.
 *
 * A two-item segmented control rather than a dropdown: with exactly two
 * languages a select costs an extra tap and hides the alternative. Renders the
 * short codes with the full name as the accessible label, so it stays legible
 * in the cramped header of a phone.
 */
export function LanguageSwitcher({ className }: { className?: string }) {
  const { locale, setLocale, t } = useLocale();

  return (
    <div
      className={`language-switcher btn-group btn-group-sm${className ? ` ${className}` : ''}`}
      role="group"
      aria-label={t('language.switchTo')}
    >
      {LOCALES.map((value: Locale) => (
        <button
          key={value}
          type="button"
          className={`btn btn-sm ${value === locale ? 'btn-primary' : 'btn-outline-secondary'}`}
          aria-pressed={value === locale}
          title={LOCALE_LABELS[value]}
          onClick={() => setLocale(value)}
        >
          {LOCALE_SHORT_LABELS[value]}
        </button>
      ))}
    </div>
  );
}
